// MessageTypers
import React from 'react';
import { connect } from 'react-redux';

import Message from './Message';

@connect((Store) => {
  return {
    typers: Store.threads.typers
  }
})

export default class MessageTypers extends React.Component {
  shouldComponentUpdate(nextProps, nextState) {
    return nextProps.typers !== this.props.typers;
  }

  guidGenerator(userId) {
      var S4 = function() {
         return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
      };
      return 'typer'+ userId + (S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4());
  }

  render() {
    return (
      <div className='typing'>
      {
        this.props.typers && this.props.typers.map((user, i) => {
          return (
            <Message
              key={'typing' + i}
              message={{
                id: this.guidGenerator(user.id),
                author: user
              }}
              isOwn={false}
              typing={true}
            />
          );
        })
      }
      </div>
    )
  }
};



// WEBPACK FOOTER //
// ./src/components/MessageTypers.jsx